import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'dashboards/counter' },

    // Redirect signed in user to the '/example'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboards/counter' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule) },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule) },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule) },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule) },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule) }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule) },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule) }
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'home', loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule) },
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            { path: 'example', loadChildren: () => import('app/modules/admin/example/example.module').then(m => m.ExampleModule) },
            { path: 'clients', loadChildren: () => import('app/modules/admin/apps/clients/clients.module').then(m => m.ClientsModule) },
            { path: 'contract-cancellations', loadChildren: () => import('app/modules/admin/apps/contracts/contracts.module').then(m => m.ContractsModule) },
            { path: 'clients-project/:projectId/:projectName', loadChildren: () => import('app/modules/admin/apps/clients/clients.module').then(m => m.ClientsModule) },
            { path: 'agents', loadChildren: () => import('app/modules/admin/apps/agents/agents.module').then(m => m.AgentsModule) },
            { path: 'projects', loadChildren: () => import('app/modules/admin/apps/projects/projects.module').then(m => m.ProjectsModule) },
            { path: 'projects-branch/:branchId/:branchName', loadChildren: () => import('app/modules/admin/apps/projects/projects.module').then(m => m.ProjectsModule) },
            { path: 'branches', loadChildren: () => import('app/modules/admin/apps/branches/branches.module').then(m => m.BranchesModule) },
            { path: 'bank-accounts', loadChildren: () => import('app/modules/admin/apps/bank-accounts/bank-accounts.module').then(m => m.BankAccountsModule) },
            { path: 'payments', loadChildren: () => import('app/modules/admin/apps/payments/payments.module').then(m => m.PaymentsModule) },
            { path: 'payables', loadChildren: () => import('app/modules/admin/apps/payables/payables.module').then(m => m.PayablesModule) },
            { path: 'deposits', loadChildren: () => import('app/modules/admin/apps/deposits/deposits.module').then(m => m.DepositsModule) },
            {
                path: 'printables', children: [
                    { path: 'soa/:contractId/:clientName', loadChildren: () => import('app/modules/admin/pages/soa/soa.module').then(m => m.SoaModule) },
                ]
            },
            {
                path: 'client', children: [
                    { path: 'contract', loadChildren: () => import('app/modules/client/contracts/client-contracts.module').then(m => m.ClientContractsModule) },
                ]
            },

            // Pages
            {
                path: 'pages', children: [
                    // Settings
                    { path: 'settings', loadChildren: () => import('app/modules/admin/pages/settings/settings.module').then(m => m.SettingsModule) },
                ]
            },
            {
                path: 'dashboards', children: [
                    { path: 'counter', loadChildren: () => import('app/modules/admin/dashboards/counter/counter.module').then(m => m.CounterModule) },
                    { path: 'client-dashboard', loadChildren: () => import('app/modules/admin/dashboards/client-dashboard/client-dashboard.module').then(m => m.ClientDashboardModule) },
                ]
            },

        ]
    }
];
